import { Children, cloneElement } from 'react';
import { mergeOverrides } from '../../overrides.js';
import { getTabOverrideStyle } from './style-utils.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const renderChildrenBecauseBasewebMessedThisUpBigTime = (children) => Children.map(children, (child) => (
  // According to Figma design, disabled tabs should not be rendered
  child.props.disabled ? null : cloneElement(child, {
    overrides: mergeOverrides({
      Tab: {
        style: getTabOverrideStyle("Tab")
      },
      TabPanel: {
        style: getTabOverrideStyle("TabPanel")
      },
      ArtworkContainer: {
        style: getTabOverrideStyle("ArtworkContainer")
      }
    }, child.props.overrides)
  })
)).map((_a) => {
  var _b = _a, { key } = _b, child = __objRest(_b, ["key"]);
  return __spreadValues({
    // Children.map internally prefixes key with `.$`, but we want to hack Baseweb's own Children.map...
    key: typeof key === "string" ? key.replace(/^\.\$/, "") : key
  }, child);
});

export { renderChildrenBecauseBasewebMessedThisUpBigTime };
